import { render, staticRenderFns } from "./NewContentAvailableToastr.vue?vue&type=template&id=37a6d0e8&scoped=true&"
import script from "./NewContentAvailableToastr.vue?vue&type=script&lang=js&"
export * from "./NewContentAvailableToastr.vue?vue&type=script&lang=js&"
import style0 from "./NewContentAvailableToastr.vue?vue&type=style&index=0&id=37a6d0e8&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "37a6d0e8",
  null
  
)

export default component.exports